<template>
  <div class="">
    <b-form-group id="groupEmail" :label-for="'email'" :label="$t('address.Email') + ' *'">
      <base-input
        :placeholder="$t('address.Email') + ' *'"
        name="email"
        autocomplete="email"
        v-validate="'required|email'"
        :value="email"
        @input="cartDetailsByEmail($event)"
        type="email"
        :validations="[
          {
            condition: errors.has('email'),
            text: errors.first('email')
          }
        ]"
      >
      </base-input>
    </b-form-group>
    <coin-card
    ref="coinCard"
    :customer="customer"
    :rewards="rewards"
    :loyalty="loyaltyThresholds"
    :disableForm="disableForm"
    :cardNumber="cardNumber"
    @updateCard="updateCard" />
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import BaseInput from 'theme/components/Form/BaseInput'
import CoinCard from 'theme/components/CoinCard/CoinCard'
import debounce from 'lodash/debounce'

export default {
  name: 'EmailAndCoinCard',
  props: {
    busListener: {
      type: String,
      required: false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      firstLoad: true,
      email: '',
      disableForm: false,
      cardNumber: '',
      customer: {},
      loyaltyThresholds: {},
      rewards: []
    }
  },
  methods: {
    init () {
      const _this = this
      this.$nextTick(() => {
        if (!_this.email) {
          _this.email = _this.$store.getters['checkout/email'] || ''
        }
        if (_this.email && _this.firstLoad) {
          return _this.cartDetails(_this.email)
            .finally(() => {
              _this.firstLoad = false
            })
        }
      })
    },
    // default values
    // to be replaced
    setupAddressForNextStep (customer) {
      let selectedAddress = 0
      if (this.$store.getters['checkout/email'] !== this.email) {
        this.$store.commit('checkout/setBillingAddress', false)
      }
      if (customer) {
        this.$store.commit('userAdmin/setAddresses', customer.addresses || [])
        if (customer.addresses && customer.addresses.length > 0) {
          // get first address and populate address of next step
          selectedAddress = customer.addresses[0].ID
          EventBus.$emit('addressList::forceUpdate', selectedAddress)
        }
      }
    },
    confirmData () {
      const _this = this
      return this.$validator.validate()
        .then((isValid) => {
          if (isValid && _this.email) {
            const customerEmail = this.$store.state.checkout.hasOwnProperty('email') ? this.$store.state.checkout.email : false
            if (!customerEmail) {
              _this.email = ''
            } else {
              _this.$emit('next-step')
            }
          }
        })
    },
    cartDetailsByEmail: debounce(function ($event) {
      const _this = this
      this.email = $event
      return this.$nextTick(() => {
        if (!this.errors.has('email') && $event) {
          _this.$store.commit('ui/showLoader')
          return _this.$store.dispatch('checkout/setEmailForGuest', _this.email)
            .finally(() => {
              _this.$store.commit('ui/hideLoader')
              return _this.cartDetails(_this.email)
            })
        }
      })
    }, 200),
    cartDetails (email) {
      const _this = this
      _this.$store.commit('ui/showLoader')
      return this.$store.dispatch('checkout/cartDetails', { email })
        .then((res) => {
          let { customer, rewards, loyaltyThresholds } = res
          _this.customer = customer
          _this.loyaltyThresholds = loyaltyThresholds
          _this.rewards = rewards
          _this.cardNumber = _this.customer && _this.customer.cardNumber ? _this.customer.cardNumber : ''
          _this.disableForm = !!_this.cardNumber
          _this.setupAddressForNextStep(customer)
          return res
        })
        .finally(() => {
          _this.$store.dispatch('cart/totals')
          _this.$store.commit('ui/hideLoader')
          // init sub components
          _this.$refs['coinCard'].init()
        })
    },
    updateCard (payload) {
      let { customer, rewards, loyaltyThresholds } = payload
      this.customer = customer
      if (customer && customer.email) {
        this.$validator.reset()
        this.cartDetailsByEmail(customer.email)
      }
      this.loyaltyThresholds = loyaltyThresholds
      this.rewards = rewards
      this.$nextTick(() => {
        this.$validator.validate()
      })
    }
  },
  mounted () {
    if (this.busListener) {
      EventBus.$on(`${this.busListener}:validateForm`, this.confirmData)
    }
  },
  destroyed () {
    if (this.busListener) {
      EventBus.$off(`${this.busListener}:validateForm`, this.confirmData)
    }
  },
  components: {
    BaseInput,
    CoinCard
  }
}
</script>
